import { render, staticRenderFns } from "./profile-inactive.component.html?vue&type=template&id=58572b80&scoped=true&"
import script from "./profile-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./profile-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./profile-inactive.component.scss?vue&type=style&index=0&id=58572b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58572b80",
  null
  
)

export default component.exports